import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Config from '../Config';
import jwtDecode from 'jwt-decode';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { ToastContainer ,toast} from 'react-toastify';

function Socialhubedit() {
  let navigate = useNavigate();
    const {handleUnauthorized } = useAuthHandling();
  
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }

    let { id } = useParams();

    const [video, setVideo] = useState({
        title: "",
        type: "",
        url:"",
        creator:'',
    });
    const [videofile, setVideofile] = useState([]);
    const [thumbnail, setThumbnail] = useState([]);
    const [videoPreview, setVideoPreview] = useState(null);
    const [thumbnailPreview, setThumbnailPreview] = useState(null);
    const [formerror, setError] = useState({});
   const [loading, setLoading] = useState(false);
    let name, value;
  
    const handleInputs = (e) => {
      name = e.target.name;
      value = e.target.value;
      setVideo({ ...video, [name]: value });
    };
  
   
    const getinfo = async (e) => {
      const res = await fetch(`${Config.apiurl}/api/v1/crm/social-hub/video/${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      });
      if (res.status === 200 ) {
        const data = await res.json();
  
        setVideo(data.data);

      } 
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");
  
      }
    };


  
    const validate = (values) => {
      const errors = {};
      if (!values.videoTitle) {
        errors.title = "Title is required!";
      }
  
      if (videofile.length===0) {
        if (!values.url) {
        errors.file = "Video is required!";
        }
      }
      if (!thumbnail) {
        errors.thumbnail = "Image is required!";
      } else if (thumbnail.type) {
        if (
            thumbnail.type === "image/jpeg" ||
          thumbnail.type === "image/jpg" ||
          thumbnail.type === "image/png"
        ) {
         console.log();
        } else {
          errors.customerImage = "Only support jpg, jpeg, png image!";
        }
      }
      return errors;
    };


    const PostData = async (e) => {
        e.preventDefault();
        setLoading(true); 
        const ress = validate(video);
        setError(ress);
      
        const token = Cookies.get("a_token"); 
        let userId;
        if (token) {
            const decodedToken = jwtDecode(token); // Decode the token
             userId = decodedToken.uId; // Extract user ID (check actual key in your token)
          
          }

        if (!ress.title && !ress.type && !ress.url && !ress.file && !ress.thumbnail) {
         
          const formData = new FormData();
          formData.append("title", video.videoTitle);
          // formData.append("videoType", video.type);
          formData.append("creator", userId);
         
          formData.append("thumbnail", thumbnail);  

          await uploadInChunks(videofile, {
            title: video.videoTitle,
            creator: userId,
            thumbnail: thumbnail,
          });

        }
        else {
          setLoading(false);
        }
         
      
       
      };
      
      const uploadInChunks = async (file, metadata) => {

         
        const chunkSize = 5 * 1024 * 1024; // 5MB
        const totalChunks = Math.ceil(file.size / chunkSize);
        try {
      
          const formData = new FormData();
          // Success message after all chunks
          for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
            const start = chunkIndex * chunkSize;
            const end = Math.min(file.size, start + chunkSize);
            const chunk = file.slice(start, end);
            // Create a fresh FormData for each chunk
            formData.append(`chunk_${chunkIndex}`, chunk);
          }
            formData.append("totalChunks", totalChunks.toString());
            formData.append("fileName", file.name);
            formData.append("title", metadata.title);
            formData.append("creator", metadata?.creator || "");
            formData.append("thumbnail", metadata?.thumbnail || "");

          const res = await fetch(`${Config.apiurl}/api/v1/crm/social-hub/update-video/${id}`, {
            method: "PUT",
            body: formData, // Send FormData instead of JSON
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          });


          if (res.status === 401) {
            handleUnauthorized();
            return uploadInChunks(file, metadata); // stop current loop
          }
        
          const data= await res.json();
          const data1=data?.data[0];
        
        // After all chunks uploaded → merge them
        const mergeForm = new FormData();
        mergeForm.append("title", metadata.title);
        mergeForm.append("creator", metadata?.creator || "");
        mergeForm.append("thumbnail", metadata?.thumbnail || "");
        mergeForm.append("totalChunks", totalChunks.toString());
        mergeForm.append("uploadId", data1?.uploadId);
        // mergeForm.append("fileName", file.name);
        mergeForm.append("status", true);
        
        const mergeRes = await fetch(`${Config.apiurl}/api/v1/crm/social-hub/merge-chunks`, {
          method: "POST",
          body: mergeForm,
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        });
    
          if (mergeRes.status === 200) {
            toast.success("Successfully updated video", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);
          } else if (mergeRes.status === 401) {
            handleUnauthorized();
            PostData();
          } else {
            toast.error("Something went wrong", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        } catch (error) {
          console.error("Error uploading video:", error);
        } finally {
          setLoading(false); // Hide loader when request completes
        }
      }

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setVideofile(file);
            setVideoPreview(URL.createObjectURL(file)); // Create a video preview
          }
      };
      const onFileChangethumb = (e) => {
        const file = e.target.files[0];
        if (file) {
            setThumbnail(file);
            setThumbnailPreview(URL.createObjectURL(file)); // Create an image preview
          }
      
      };

      useEffect(()=>{
        getinfo();
     },[])
  return (

    <>
    {loading && (
        <div className="overlay_spin ">
          <div className="spinner_spin "></div>
          <p>Uploading... Please wait</p>
        </div>
      )}
   
    <div className="container-scroller">
    <Navbar />
    <div className="container-fluid page-body-wrapper">
      <Sidebar />
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Youtube Videos</h4>
                  <p className="card-description">Edit Video</p>
                  <form className="forms-sample" onSubmit={PostData}>
                    {/* <form className="forms-sample"> */}
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">Title</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="Title"
                        name="videoTitle"
                        value={video.videoTitle}
                        onChange={handleInputs}
                      />
                      <label style={{ color: "red" }}>
                        {formerror.title}
                      </label>
                    </div>
                   
                   
                              <div className="form-group">
                                <label htmlFor="exampleInputEmail1">
                                  Video 
                                </label>
                                <br></br>
                                <input
                                  type="file"
                                  name="file"
                                  accept="video/*"
                                  onChange={onFileChange}
                                />
                                  {videoPreview ?
                                          <video  className="video_previews" width="300" controls>
                                          <source src={videoPreview} type="video/mp4" />
                                          Your browser does not support the video tag.
                                          </video>
                                      :video?.url?
                                      <video className="video_previews" width="300" controls>
                                        <source src={video.url} type="video/mp4" />
                                        Your browser does not support the video tag.
                                      </video>
                                      :""
                                  }

                                <label style={{ color: "red" }}>
                                  {formerror.file}
                                </label>
                              </div>
                          
                
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                          Thumbnail 
                          </label>
                          <br></br>
                          <input
                            type="file"
                            name="thumbnail"
                           
                            onChange={onFileChangethumb}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.thumbnail}
                          </label>
                          {thumbnailPreview ?
                          <img  className="video_previews" style={{width:"300px",height:"auto"}} src={thumbnailPreview} alt="Thumbnail Preview" width="150" />
                            :video?.thumbnail?
                            <img  className="video_previews" style={{width:"300px",height:"auto"}}  src={video?.thumbnail} alt="Thumbnail Preview" width="150" />
                            :""
                        }
                        </div>
                
                    <button
                      type="submit"
                      onClick={PostData}
                      className="btn btn-primary me-2"
                    >
                      Submit
                    </button>
                    <ToastContainer />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  </div>
  </>
  )
}

export default Socialhubedit
